import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker, InputNumber, Switch, Tabs, Card, AutoComplete } from "antd";
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, formatNumber, formatDate, dayjsDate, getobjkeys, getyhzh, checkp } from '../../utils/functions'
import renderFileList from "../../components/renderFileList";
import ShEditor from "../../components/ShEditor";
import ExpenditureDetails from "../cwb/ExpenditureDetails";
import CustModal from "../../components/ShowModal";

const { Option } = Select;
function Cksh() {
    const { type } = useParams();
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [bgsItem, setbgsItem] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(30);
    const [activeKey, setActiveKey] = useState('0');

    const [yhzh, setYhzh] = useState([]);
    const [form] = Form.useForm();
    const pageSizeOptions = [10, 20, 50, 100, 500];
    const [kmdata, setKmdata] = useState([]);
    const [editingRecord, setEditingRecord] = useState(null);
    const [flcount, setflcount] = useState(1);
    const [shResult, setShResult] = useState({});
    const [lyDate, setLydata] = useState(null);
    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = async () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            let res = [], tos = 0;
            try {
                const params = { type, s: activeKey, page: currentPage, limit: pageSize };
                const response = await webPost('ckshb', params);
                if (response) {
                    res = response;
                    tos = response.length;
                }
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
            setData(res);
            setTotal(tos);
        }
        fetchItems();
    }, [currentPage, pageSize, filters, freshData, activeKey, type]);

    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 80, fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '项目名称', dataIndex: 'xmmc' },
        { title: '付款单位', dataIndex: 'receipt_company' },
        { title: '制单人', dataIndex: 'maker_name' },
        { title: '制单日期', dataIndex: 'make_date' },
        { title: '收入类别', dataIndex: 'income_type' },
        { title: '结算方式', dataIndex: 'settlement_method' },
        { title: '收款户名', dataIndex: 'payer_name' },
        { title: '备注', dataIndex: 'remark' },
        { title: '本次支出金额', dataIndex: 'this_receipt_amount' },
        { title: '附件', dataIndex: 'attachment', render: (t) => renderFileList(t) },
        (checkp(['cwsz1']) || checkp(['cwsz2'])) && {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => <Button type="link" onClick={() => showModal(record, "scbs")} >开始审核</Button>,
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        if (!record) {
            message.error("错误的参数");
            return;
        }
        setEditingRecord(record);
        setModalVisible(action);
    };

    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSuccess = async (r) => {
        if (!editingRecord?.id) return message.error("错误的参数");
        if (Number(editingRecord?.shstep) === 2) {
            if (r.result === -1) {
                const params = { id: editingRecord.id, step: 2, s: activeKey, ...r, sn: editingRecord.sn };
                const res = await webPost('ckshbsave', params);
                if (res) {
                    message.success('审核成功');
                    setfreshData(Math.random()); //强制刷新数据
                    handleModalClose();
                }
                return;
            }
            setLoading(true);
            setShResult(r);
            setModalVisible('fl');
            form.setFieldValue('cbp_amount',editingRecord?.this_receipt_amount)
            const res1 = await getyhzh(webPost);
            setYhzh(res1);
            const kms = await webPost('cktypelist', {});
            if (kms) setKmdata(kms);
            setLoading(false);
        } else {
            const params = { id: editingRecord.id, step: 1, s: activeKey, ...r, sn: editingRecord.sn };
            const res = await webPost('ckshbsave', params);
            if (res) {
                message.success('审核成功');
                setfreshData(Math.random()); //强制刷新数据
                handleModalClose();
            }
        }
    };
    const saveSubmit = async () => {
        const values = await form.validateFields();
        const params = { id: editingRecord.id, step: 2, ...shResult, ...values, sn: editingRecord.sn, xmmc: editingRecord.xmmc, flcount };
        console.log(params);
        const res = await webPost('ckshbsave', params);
        if (res) {
            message.success('审核成功');
            setfreshData(Math.random()); //强制刷新数据
            handleModalClose();
        }
    }
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    const [skey, setSkey] = useState('');
    const [options, setOptions] = useState([]);
    const searchXm = async (i) => {
        const res = await webPost('getXmmcBykey', { skey });
        if (res) {
            const newops = [...options];
            newops[i] = res;
            setOptions(newops);
            form.setFieldValue(`xmmc${i}`, res[0]?.xmmc);
            form.setFieldValue(`sn${i}`, res[0]?.sn);
        }
    }
    const setXmsn = (v, i) => {
        const currentOptions = options[i] || [];
        for (const it of currentOptions) {
            const matchStr = `${it.sn}……${it.xmmc}`;
            if (v === matchStr) {
                console.log(it);
                form.setFieldsValue({
                    [`sn${i}`]: it.sn, [`xmmc${i}`]: it.xmmc
                });
                break;
            }
        }
    };
    const setCkPay = (v, i) => {
        if (lyDate && lyDate?.ly) {
            const _ly = lyDate.ly.find((it) => Number(v) === Number(it.id));
            if (_ly) {
                form.setFieldValue(`pay_bank_id${i}`, _ly.bank_id);
                form.setFieldValue(`amt${i}`, _ly.amount);
            } else {
                form.setFieldValue(`pay_bank_id${i}`, undefined);
                form.setFieldValue(`amt${i}`, undefined);
            }
        } else {
            form.setFieldValue(`pay_bank_id${i}`, undefined);
            form.setFieldValue(`amt${i}`, undefined);
        }
    }
    return (
        <FullHeightLayout
            isloading={loading}
            headerContent={null}
            bodyContent={
                <>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey={(record, index) => index}
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 1800,
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                    />
                </>
            }
            footerContent={<div style={{
                display: 'flex', justifyContent: 'flex-end',
                alignItems: 'center',
            }}>
                <CustModal
                    title={'审核结果'}
                    open={modalVisible === 'scbs'}
                    onCancel={handleModalClose}
                    okText="保存"
                    cancelText="取消"
                    footer={null}
                >
                    <ShEditor onChange={saveSuccess}>
                        <ExpenditureDetails item={editingRecord} lyDate={(v) => setLydata(v)} />
                        <div>审核备注1：{editingRecord?.remark1 || '无'}</div>
                    </ShEditor>
                </CustModal>
                <CustModal
                    title={'支出分流'}
                    open={modalVisible === 'fl'}
                    onCancel={handleModalClose}
                    onOk={saveSubmit}
                    okText="保存审核结果"
                    cancelText="取消"
                    isloading={loading}
                >
                    <Form form={form} >
                        <Form.Item name="cbp_amount" label="成本票金额">
                            <Input />
                        </Form.Item>
                        
                        {
                            Array.from({ length: flcount }, (_, index) => (
                                <Card key={`fl_${index}`}>
                                    <Form.Item label="项目搜索">
                                        <Space size='middle'>
                                            <Input onChange={(e) => { setSkey(e.target.value) }} placeholder="输入项目编号或项目名称" />
                                            <Button onClick={() => { searchXm(index) }} >搜索</Button>
                                        </Space>
                                    </Form.Item>

                                    <Form.Item hidden name={`sn${index}`}><Input /></Form.Item>
                                    <Form.Item hidden name={`xmmc${index}`}><Input /></Form.Item>
                                    <Form.Item label="转入项目名称" name={`snxmmc${index}`}>
                                        <AutoComplete options={options[index] && options[index].map(it => ({ value: `${it.sn}……${it.xmmc}` }))}
                                            onChange={(v) => { setXmsn(v, index) }} />
                                    </Form.Item>
                                    <Form.Item label="支付金额" name={`amt${index}`} dependencies={[`sn${index}`]}>
                                        <InputNumber style={{ width: '100%' }} />
                                    </Form.Item>
                                    <Form.Item hidden name={`kmmc${index}`}><Input /></Form.Item>
                                    <Form.Item label="费用科目" name={`km${index}`}>
                                        <Select
                                            showSearch
                                            placeholder="输入科目代码或名称进行搜索"
                                            optionFilterProp="label"
                                            filterOption={(input, option) => {
                                                const inputLower = input.toLowerCase();
                                                const km = option.km?.toString().toLowerCase() || '';
                                                const kmmc = option.kmmc?.toLowerCase() || '';
                                                return km.includes(inputLower) || kmmc.includes(inputLower);
                                            }}
                                            onChange={(value) => {
                                                const matched = kmdata.find(it => it.km === value);
                                                if (matched) {
                                                    form.setFieldsValue({ [`kmmc${index}`]: matched.kmmc });
                                                }
                                            }}
                                        >
                                            {kmdata?.map((item) => (
                                                <Select.Option
                                                    key={`${item.id}-${item.km}`}
                                                    value={item.km}
                                                    km={item.km}
                                                    kmmc={item.kmmc}
                                                    label={`${item.km} ${item.kmmc}`}
                                                >
                                                    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                                                        <span>{item.km}</span>
                                                        <span style={{ color: '#666', fontSize: '12px' }}>{item.kmmc}</span>
                                                    </Space>
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item name={`bank_id_${index}`} label="选择转入账户">
                                        <Select placeholder="选择转入账户">{yhzh && yhzh.map(it => {
                                            return <Option key={it.id} value={it.id}>{`${it.dw}-${it.mc}-${it.zh}`}</Option>
                                        })}</Select>
                                    </Form.Item>
                                </Card>
                            ))
                        }
                        <Form.Item label={<a onClick={() => { setflcount(prev => (1 + prev)); }}>增加分流列表</a>} ></Form.Item>


                    </Form>
                </CustModal>
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                    onChange={onPageChange}
                    pageSizeOptions={pageSizeOptions}
                />
            </div>}
        />
    )
}


export default Cksh;
